class AccountClubDomMove extends HTMLElement {
  connectedCallback() {
    const view = new URLSearchParams(window.location.search).get("view");
    const isAccountClubTemplate =
      document.body.classList.contains("template-page-account-club-bero") ||
      window.location.pathname.includes("account-club-bero");

    if (view !== "club" && !isAccountClubTemplate) return;

    let moved = false;

    const move = () => {
      if (moved) return;

      const source =
        document.querySelector("main .account-novel-app") ||
        document.querySelector("#account .section.pbj-rich-text > .isolate");
      if (!source) return;

      const dashboard = document.querySelector("#rivo-account-dashboard");
      const firstCard = dashboard?.querySelector(".rivo-account-card");
      const cardContent = firstCard?.querySelector(
        ".rivo-account-card-content"
      );

      if (firstCard && cardContent) {
        if (!firstCard.contains(source)) {
          source.style.display = "block";
          cardContent.insertAdjacentElement("afterend", source);
        }

        const originalSection = source.closest("section");
        if (originalSection && !originalSection.contains(source)) {
          const hasAnyElement = !!originalSection.querySelector("*");
          if (!hasAnyElement) originalSection.style.display = "none";
        }

        moved = true;
        observer.disconnect();
      }
    };

    const observer = new MutationObserver(move);
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(move, 200);
  }
}

customElements.define("account-club-dom-move", AccountClubDomMove);
